import type { KitchenStatus } from 'shared-models/browser';

export const formatMoney = (value: number) =>
  new Intl.NumberFormat('he-IL', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value);

export const formatDateTime = (value: string | null | undefined) =>
  value ? new Date(value).toLocaleString('he-IL') : '-';

type KdsStatusClasses = {
  kdsStatus: string;
  kdsStatusCooking: string;
  kdsStatusReady: string;
  kdsStatusDone: string;
  kdsStatusMuted: string;
};

// Maps a kitchen status to the audit color class, reusing the KDS board's status tokens.
export const kdsStatusClassName = (
  classes: KdsStatusClasses,
  status: KitchenStatus | null | undefined,
): string => {
  const color =
    status === 'COOKING'
      ? classes.kdsStatusCooking
      : status === 'READY'
        ? classes.kdsStatusReady
        : status === 'DONE'
          ? classes.kdsStatusDone
          : classes.kdsStatusMuted;
  return `${classes.kdsStatus} ${color}`;
};
